/*Auto-generated at pre-build.js*/ export class BuildDetails { public static readonly isoDate = '2026-11-04T16:11:34.713Z'; }